import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoginForm from "../components/Auth/LoginForm";
import RegisterForm from "../components/Auth/RegisterForm";

const Login = () => {
  const { isAuthenticated } = useAuth();
  const [isLogin, setIsLogin] = useState(true);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-100 to-indigo-200">
      <div className="max-w-4xl w-full flex flex-col md:flex-row items-center md:items-start gap-10">

        {/* Branding */}
        <div className="md:w-1/2 text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            🚀 AI Project Generator
          </h1>

          <p className="text-lg text-gray-700 mb-6">
            Build complete production-ready projects using AI.
          </p>

          <div className="text-gray-600 space-y-2">
            <p>✔ Generate any framework or language</p>
            <p>✔ Production-ready code</p>
            <p>✔ Full project structure</p>
            <p>✔ Zero configuration needed</p>
          </div>
        </div>

        {/* Auth Panel */}
        <div className="md:w-1/2 w-full">
          {isLogin ? (
            <LoginForm onSwitchToRegister={() => setIsLogin(false)} />
          ) : (
            <RegisterForm onSwitchToLogin={() => setIsLogin(true)} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
